<template>
  <form class="bofi-c-form" @submit.prevent="calculateLoan">
    <fieldset>
      <legend>
        <span class="visually-hidden">{{
            messages["bofi_invisible_title"]
          }}</span>
      </legend>
      <div
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-currency"
        id="net_income"
      >
        <div id="error_wmform_net_income" v-if="$v.form.data.income.$error">
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label id="label_income" for="income"
          >{{ messages["bofi_netincome_label"] }}
            <span class="required">*</span>
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_netincome_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <input
            type="number"
            name="income"
            id="income"
            v-model.number="form.data.income"
            size="35"
            data-fragment-tag=""
            :class="{ error: $v.form.data.income.$error }"
          />
        </div>
        <div class="wm-field-helptext"></div>
      </div>

      <div
        class="gridelement wm-field contentelement wm_form_element contentelement_style bofi-o-select"
      >
        <div class="wm-field-label">
          <label class="label "
          >{{ messages["bofi_familycomposition_label"] }}

            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_familycomposition_tooltip']" />
          </label>
        </div>
        <div class="o-select">
          <select
            id="personal-state"
            name="personal-state"
            v-model="form.data.selectedBorrowingStandard"
          >
            <option hidden disabled selected value>{{
                messages["bofi_select_default"]
              }}
            </option>
            <option
              v-for="standard in form.data.borrowingStandards"
              :value="standard"
              v-bind:key="standard.id"
            >{{ messages["bofi_familycomposition_" + standard.id] }}
            </option>
          </select>
        </div>
        <div
          id="error_wmform_selected_borrowing_standard"
          v-if="$v.form.data.selectedBorrowingStandard.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
      </div>

      <div
        v-if="hasPartnerIncome"
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-currency"
      >
        <div
          id="error_wmform_partner_income"
          v-if="$v.form.data.incomePartner.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label id="label-income-partner" for="income-partner"
          >{{ messages["bofi_partnerincome_label"] }}
            <span class="required">*</span>
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_partnerincome_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <input
            type="number"
            name="income-partner"
            id="income-partner"
            v-model.number="form.data.incomePartner"
            size="35"
            data-fragment-tag=""
            :class="{ error: $v.form.data.incomePartner.$error }"
          />
        </div>
        <div class="wm-field-helptext"></div>
      </div>

      <div
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-select"
      >
        <div class="wm-field-label">
          <label class="label"
          >{{ messages["bofi_livingsituation_label"] }}

            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_livingsituation_tooltip']" />
          </label>
        </div>
        <div class="o-select">
          <select
            name="living-situation"
            id="living-situation"
            v-model="form.data.livingSituation"
          >
            <option hidden disabled selected value>{{
                messages["bofi_select_default"]
              }}
            </option>
            <option
              v-for="item in form.data.livingSituations"
              :value="item"
              v-bind:key="item"
            >
              {{ messages["bofi_livingsituation_" + item] }}
            </option>
          </select>
        </div>
        <div
          id="error_wmform_living"
          v-if="$v.form.data.livingSituation.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
      </div>

      <div
        v-if="hasLivingCosts"
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-currency"
      >
        <div
          id="error_wmform_cost_living"
          v-if="$v.form.data.costLiving.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label id="label-cost-living" for="cost-living">
            {{ livingCostsDescription.label }}
            <span class="required">*</span>
            <eclipse disable-arrow tooltip-bottom :text="livingCostsDescription.tooltip" />
          </label>
        </div>
        <div class="wm-field-input">
          <input
            type="number"
            name="cost-living"
            id="cost-living"
            v-model.number="form.data.costLiving"
            size="35"
            data-fragment-tag=""
            :class="{ error: $v.form.data.costLiving.$error }"
          />
        </div>
        <div class="wm-field-helptext"></div>
      </div>

      <div
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-toggle"
      >
        <div
          id="error_wmform_active_loans"
          v-if="$v.form.data.activeLoans.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label class="label"
          >{{ messages["bofi_activeloans_label"] }}
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_activeloans_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <ul class="wm-field-list">
            <li>
              <input
                type="radio"
                name="active_loans"
                value="true"
                id="active_loans_true"
                data-fragment-tag=""
                v-model="form.data.activeLoans"
              />
              <label
                id="active_loans_label_true"
                for="active_loans_true"
                class="wmradio_checkbox_item_label"
              >{{ messages["bofi_radio_yes"] }}</label
              >
            </li>
            <li>
              <input
                type="radio"
                name="active_loans"
                value="false"
                id="active_loans_false"
                data-fragment-tag=""
                v-model="form.data.activeLoans"
              />
              <label
                id="active_loans_label_false"
                for="active_loans_false"
                class="wmradio_checkbox_item_label"
              >{{ messages["bofi_radio_no"] }}</label
              >
            </li>
          </ul>
        </div>
      </div>

      <div
        v-if="hasActiveLoans"
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-currency"
      >
        <div id="error_wmform_cost_loans" v-if="$v.form.data.costLoans.$error">
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label id="label-cost-loans" for="cost-loans">
            {{ messages["bofi_loancost_label"] }}
            <span class="required">*</span>
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_loancost_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <input
            type="number"
            name="cost-loans"
            id="cost-loans"
            v-model.number="form.data.costLoans"
            size="35"
            data-fragment-tag=""
            :class="{ error: $v.form.data.costLoans.$error }"
          />
        </div>
        <div class="wm-field-helptext"></div>
      </div>

      <div
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-toggle"
      >
        <div
          id="error_wmform_child_support"
          v-if="$v.form.data.childSupport.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label class="label"
          >{{ messages["bofi_alimonysituation_label"] }}
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_alimonysituation_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <ul class="wm-field-list">
            <li>
              <input
                type="radio"
                name="child_support"
                value="true"
                id="child_support_input_yes"
                data-fragment-tag=""
                v-model="form.data.childSupport"
              />
              <label
                id="child_support_yes"
                for="child_support_input_yes"
                class="wmradio_checkbox_item_label"
              >{{ messages["bofi_radio_yes"] }}</label
              >
            </li>
            <li>
              <input
                type="radio"
                name="child_support"
                value="false"
                id="child_support_input_no"
                data-fragment-tag=""
                v-model="form.data.childSupport"
              />
              <label
                id="child_support_no"
                for="child_support_input_no"
                class="wmradio_checkbox_item_label"
              >{{ messages["bofi_radio_no"] }}</label
              >
            </li>
          </ul>
        </div>
      </div>

      <div
        v-if="hasChildSupport"
        class="wm-field contentelement wm_form_element contentelement_style bofi-o-currency"
      >
        <div
          id="error_wmform_cost_child_support"
          v-if="$v.form.data.costChildSupport.$error"
        >
          <ul>
            <li>{{ messages["bofi_required"] }}</li>
          </ul>
        </div>
        <div class="wm-field-label">
          <label id="label-cost-child-support" for="cost-child-support">
            {{ messages["bofi_alimonycosts_label"] }}
            <span class="required">*</span>
            <eclipse disable-arrow tooltip-bottom :text="messages['bofi_alimonycosts_tooltip']" />
          </label>
        </div>
        <div class="wm-field-input">
          <input
            type="number"
            name="cost-loans"
            id="cost-child-support"
            v-model.number="form.data.costChildSupport"
            size="35"
            data-fragment-tag=""
            :class="{ error: $v.form.data.costChildSupport.$error }"
          />
        </div>
        <div class="wm-field-helptext"></div>
      </div>
      <div class="wm-field-spacing">
        <input
          type="button"
          class="o-btn"
          :value="messages['bofi_calculate_now']"
          @click="calculateLoan"
        />
      </div>

      <div
        class="l-center-content"
        v-if="form.data.calculatedAmount !== null && !form.error && !form.loadCalculationError"
      >
        <div class="c-green-block">
          <h2>
            {{
              messages["bofi_calculate_maximum_capacity_result_title"].replace(
                "%s",
                form.data.calculatedAmount,
              )
            }}
          </h2>
          <p>
            {{
              messages[
                "bofi_calculate_maximum_capacity_result_description"
                ].replace("%s", form.data.calculatedAmount)
            }}
          </p>
        </div>
        <p class="text-light">
          {{ messages["bofi_calculate_maximum_capacity_result_disclaimer"] }}
        </p>
      </div>

      <div
        class="wm-field contentelement wm_form_element contentelement_style"
        v-if="form.error"
      >
        <div id="error_wmform_server_error">
          <ul>
            <li>{{ messages["bofi_server_error"] }}</li>
          </ul>
        </div>
      </div>

      <div
        class="wm-field contentelement wm_form_element contentelement_style"
        v-if="form.loadCalculationError"
      >
        <div id="error_wmform_server_error">
          <ul>
            <li>{{ messages["bofi_server_calculate_error"] }}</li>
          </ul>
        </div>
      </div>

    </fieldset>
  </form>
</template>

<script>
import * as Api from "../../api";
import * as BofiUtils from "../../utils";
import { Eclipse } from "../../includes";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

const borrowingStandards = [
  { id: "SINGLE", base: 814, extra: 40, max: 1190 },
  { id: "SINGLE_WITH_CHILDREN", base: 903, extra: 226, max: 1425 },
  { id: "LIVING_TOGETHER", base: 1261, extra: 119, max: 1649 },
  { id: "LIVING_TOGETHER_WITH_CHILDREN", base: 1251, extra: 244, max: 1739 },
];

const livingSituations = ["mortgage", "rent", "boardwages"];

export default {
  name: "CalculateMaximumLoanCapacityForm",
  components: { Eclipse },
  mixins: [validationMixin],
  data() {
    return {
      messages: {
        bofi_invisible_title: "Hoeveel kan ik lenen",
        bofi_familycomposition_SINGLE: "Alleenstaand",
        bofi_familycomposition_SINGLE_WITH_CHILDREN:
          "Alleenstaand met kind(eren)",
        bofi_familycomposition_LIVING_TOGETHER: "Gehuwd / Samenwonend",
        bofi_familycomposition_LIVING_TOGETHER_WITH_CHILDREN:
          "Gehuwd / Samenwonend met kind(eren)",
        bofi_familycomposition_label: "Wat is je burgelijke staat?",
        bofi_familycomposition_tooltip:
          "Als je samenwoont of gehuwd bent nemen we het netto maandinkomen van je partner ook mee in de berekening van het maximale leenbedrag.",
        bofi_radio_yes: "Ja",
        bofi_radio_no: "Nee",
        bofi_select_default: "Maak een keuze",
        bofi_required: "Dit veld is verplicht",
        bofi_netincome_label: "Wat is je netto maandinkomen?",
        bofi_netincome_tooltip:
          "Je netto maandinkomen is het bedrag dat je daadwerkelijk op je betaalrekening ontvangt, zonder reiskosten- of onkostenvergoeding.",
        bofi_partnerincome_label:
          "Wat is het netto maandinkomen van je partner?",
        bofi_partnerincome_tooltip:
          "Het netto maandinkomen van je partner is het bedrag dat je partner daadwerkelijk op zijn of haar betaalrekening ontvangt, zonder reiskosten- of onkostenvergoeding.",
        bofi_livingsituation_mortgage: "Koopwoning",
        bofi_livingsituation_rent: "Huurwoning / Kamers",
        bofi_livingsituation_boardwages: "Thuiswonend / Inwonend",
        bofi_livingsituation_label: "Wat is je woonsituatie?",
        bofi_livingsituation_tooltip:
          "Om te berekenen wat je maximaal kunt lenen hebben we wat informatie nodig over je woonsituatie.",
        bofi_activeloans_label: "Heb je één of meerdere en leningen lopen?",
        bofi_activeloans_tooltip:
          "Met een lening bedoelen we ook een tweede hypotheek, studieschuld of het bedrag dat je rood staat op je creditcard.",
        bofi_loancost_label: "Wat betaal je per maand aan je huidige leningen?",
        bofi_loancost_tooltip:
          "Vul hier het bedrag in dat je maandelijks betaalt aan de aflossing van je leningen. Met een lening bedoelen we ook een tweede hypotheek, studieschuld of het bedrag dat je rood staat op je creditcard.",
        bofi_alimonysituation_label: "Betaal je alimentatie?",
        bofi_alimonysituation_tooltip:
          "Dit willen we weten, omdat de te betalen alimentatie van invloed is op het maximale leenbedrag. Met alimentatie bedoelen we kinderalimentatie en partneralimentatie.",
        bofi_alimonycosts_label: "Wat betaal je per maand aan alimentatie?",
        bofi_alimonycosts_tooltip:
          "Vul hier het bedrag in dat je maandelijks betaalt aan alimentatie. Met alimentatie bedoelen we kinderalimentatie en partneralimentatie.",
        bofi_calculate_now: "Bereken nu",
        bofi_server_error: "Er is een fout opgetreden op de server, probeer het later nog eens.",
        bofi_server_calculate_error: "Helaas. Op basis van jouw ingevulde gegevens is het niet mogelijk om verantwoord geld te lenen.",
        bofi_calculate_maximum_capacity_result_title: "Je kunt € %s lenen",
        bofi_calculate_maximum_capacity_result_description:
          "Op basis van de door jou ingevulde gegevens kun je maximaal een bedrag van € %s verantwoord lenen. Dit is een indicatie en geeft je een idee van wat je ongeveer kunt lenen.",
        bofi_calculate_maximum_capacity_result_disclaimer:
          "De berekening is een indicatie. Aan de berekening kunnen geen rechten worden ontleend.",
        bofi_livingcosts_mortgage_label:
          "Wat is je bruto hypotheekbedrag per maand?",
        bofi_livingcosts_mortgage_tooltip:
          "Je bruto hypotheekbedrag is het bedrag dat je elke maand betaalt aan je hypotheekverstrekker.",
        bofi_livingcosts_rent_label: "Wat is je kale huur per maand?",
        bofi_livingcosts_rent_tooltip:
          "Je kale huur is het bedrag dat je elke maand betaalt aan huur, zonder de huurtoeslag.",
        bofi_livingcosts_boardwages_label: "Wat is je kostgeld per maand?",
        bofi_livingcosts_boardwages_tooltip:
          "Je kostgeld is het bedrag dat je elke maand betaalt om te kunnen wonen.",
      },
      form: {
        error: false,
        loadCalculationError: false,
        data: {
          borrowingStandards,
          livingSituations,
          selectedBorrowingStandard: null,
          income: null,
          incomePartner: null,
          personalState: null,
          livingSituation: null,
          activeLoans: null,
          childSupport: null,
          costLiving: null,
          costLoans: null,
          costChildSupport: null,
          calculatedAmount: null,
        },
      },
    };
  },
  watch: {
    data: function(newVal) {
      this.form.data = newVal;
    },
  },
  validations() {
    // default validation wrapped in the data object.
    let data = {
      income: {
        required,
      },
      selectedBorrowingStandard: {
        required,
      },
      livingSituation: {
        required,
      },
      activeLoans: {
        required,
      },
      childSupport: {
        required,
      },
    };

    if (
      this.form.data.selectedBorrowingStandard !== null &&
      (this.form.data.selectedBorrowingStandard.id === "LIVING_TOGETHER" ||
        this.form.data.selectedBorrowingStandard.id ===
        "LIVING_TOGETHER_WITH_CHILDREN")
    ) {
      const extraValidation = {
        incomePartner: {
          required,
        },
      };
      this.augment(data, extraValidation);
    }

    if (this.form.data.livingSituation !== null) {
      const extraValidation = {
        costLiving: {
          required,
        },
      };
      this.augment(data, extraValidation);
    }

    if (this.form.data.activeLoans === "true") {
      const extraValidation = {
        costLoans: {
          required,
        },
      };
      this.augment(data, extraValidation);
    }

    if (this.form.data.childSupport === "true") {
      const extraValidation = {
        costChildSupport: {
          required,
        },
      };
      this.augment(data, extraValidation);
    }

    return {
      form: {
        data,
      },
    };
  },
  computed: {
    hasLivingCosts: function() {
      return this.form.data.livingSituation !== null;
    },
    hasPartnerIncome: function() {
      if (this.form.data.selectedBorrowingStandard !== null) {
        return (
          this.form.data.selectedBorrowingStandard.id === "LIVING_TOGETHER" ||
          this.form.data.selectedBorrowingStandard.id ===
          "LIVING_TOGETHER_WITH_CHILDREN"
        );
      } else {
        return false;
      }
    },
    hasActiveLoans: function() {
      return this.form.data.activeLoans === "true";
    },
    hasChildSupport: function() {
      return this.form.data.childSupport === "true";
    },
    livingCostsDescription: function() {
      let living = {
        label: "",
        tooltip: "",
      };
      if (this.form.data.livingSituation.includes("mortgage")) {
        living.label = this.messages["bofi_livingcosts_mortgage_label"];
        living.tooltip = this.messages["bofi_livingcosts_mortgage_tooltip"];
      } else if (this.form.data.livingSituation.includes("rent")) {
        living.label = this.messages["bofi_livingcosts_rent_label"];
        living.tooltip = this.messages["bofi_livingcosts_rent_tooltip"];
      } else if (this.form.data.livingSituation.includes("boardwages")) {
        living.label = this.messages["bofi_livingcosts_boardwages_label"];
        living.tooltip = this.messages["bofi_livingcosts_boardwages_tooltip"];
      }
      return living;
    },
  },
  methods: {
    calculateLoan() {
      const self = this;
      self.$v.form.data.$touch();

      if (!self.$v.form.data.$invalid) {
        let totalIncome = this.form.data.income + (this.form.data.incomePartner || 0);

        let requestDto = {
          totalIncomeAfterTax: totalIncome,
          monthlyHousingCosts: this.form.data.costLiving,
          totalMonthlyLoanPayOff: this.form.data.costLoans,
          totalAlimony: this.form.data.costChildSupport,
          familyComposition: this.form.data.selectedBorrowingStandard.id,
        };

        // Reset errors
        self.form.error = false;
        self.form.loadCalculationError = false;

        // Calculate max loan
        Api.Credit.getMaximumLoanCapacity(requestDto)
          .then(data => {
            self.form.error = false;
            if (data.maximumLoanCapacity) {
              self.form.data.calculatedAmount = BofiUtils.formatMoney(
                data.maximumLoanCapacity,
              );
            } else {
              self.form.loadCalculationError = true;
            }
          })
          .catch(() => {
            self.form.error = true;
          });
      }
    },
    // add properties of Obj2 to Obj1
    augment(Obj1, Obj2) {
      let prop;
      for (prop in Obj2) {
        if (Object.prototype.hasOwnProperty.call(Obj2, prop) && !Obj1[prop]) {
          Obj1[prop] = Obj2[prop];
        }
      }
    },
  },
};
</script>
